import {
  Select,
  Option,
  Input,
  Menu,
  Submenu,
  MenuItem,
  Image,
  Tree,
  Tag,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

// import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

export default {
  install: Vue => {
    // Vue.component(CollapseTransition.name, CollapseTransition);
    // Vue.use(Select);
    // Vue.use(Option);
    // Vue.use(Input);
    // Vue.use(Menu);
    // Vue.use(Submenu);
    // Vue.use(MenuItem);
    // Vue.use(Image);
    // Vue.use(Tree);
    // Vue.use(Tag);
    // Vue.use(Dropdown);
    // Vue.use(DropdownMenu);
    // Vue.use(DropdownItem);
  },
};
